import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { Button, Classes, Dialog } from "@blueprintjs/core";
import { MDBBtn } from "mdbreact";
import { toast } from "react-toastify";
import { TabelaSimplesExcessoStore } from "../../stores/admin/TabelaSimplesExcessoStore";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';

@observer
export class TabelaSimplesExcessoPage extends React.Component<{}, {}>{

  obs = observable({
    open_create: false as boolean,
  })

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Tabela Simples Nacional Excesso");

    await TabelaSimplesExcessoStore.handleGetFaixas()
  }

  handleCreate() {
    this.obs.open_create = true
  }

  async handleSaveCreate(tabela) {
    let data = tabela[0]

    let pis = data.pis.toString().replace(",", ".")
    let iss = data.iss.toString().replace(",", ".")
    let irpj = data.irpj.toString().replace(",", ".")
    let ipi = data.ipi.toString().replace(",", ".")
    let csll = data.csll.toString().replace(",", ".")
    let cpp = data.cpp.toString().replace(",", ".")
    let icms = data.icms.toString().replace(",", ".")
    let cofins = data.cofins.toString().replace(",", ".")
    let anexo = data.anexo.toString().replace(",", ".")

    if (isNaN(parseFloat(pis)) || isNaN(parseFloat(iss)) || isNaN(parseFloat(irpj)) || isNaN(parseFloat(ipi)) || isNaN(parseFloat(csll)) || isNaN(parseFloat(cpp)) || isNaN(parseFloat(icms)) || isNaN(parseFloat(cofins)) || isNaN(parseFloat(anexo))) {
      toast.error("São aceitos somente números", {});
      return
    }

    let params = {
      "pis": parseFloat(pis),
      "iss": parseFloat(iss),
      "irpj": parseFloat(irpj),
      "ipi": parseFloat(ipi),
      "csll": parseFloat(csll),
      "cpp": parseFloat(cpp),
      "icms": parseFloat(icms),
      "cofins": parseFloat(cofins),
      "anexo": parseFloat(anexo)
    }

    this.obs.open_create = false

    let res = await TabelaSimplesExcessoStore.handleCreate(params)

    if (res) {

      await TabelaSimplesExcessoStore.handleGetFaixas()

    }

  }

  render() {

    const beforeSaveCell = async (oldValue, newValue, row, column, done) => {

      let valor = newValue == "" ? "0" : newValue.replace(",", ".")

      if (isNaN(parseFloat(valor))) {
        toast.error("São aceitos somente números", {});
        return false
      }

      let res = await TabelaSimplesExcessoStore.handleUpdateValue(row._id, column.dataField, parseFloat(valor))

      if (res) {

        await TabelaSimplesExcessoStore.handleGetFaixas()

      }

    }

    const valuesFormatter = (cell, row) => {

      if (cell) {
        return (<span>{cell + " %"}</span>);
      }

      return (<span>Não Optante</span>);

    }

    const valuesFormatterNew = (cell, row) => {

      return (<span>{cell + " %"}</span>);

    }

    let data = [{
      "pis": 0,
      "iss": 0,
      "irpj": 0,
      "ipi": 0,
      "csll": 0,
      "cpp": 0,
      "icms": 0,
      "cofins": 0,
      "anexo": "",
    }]

    const valid = (newValue, row, column) => {

      if (isNaN(parseFloat(newValue))) {
        toast.error("O valor deve ser numérico", {});
        return { valid: false };
      }

      return true
    }

    const columns = [
      { dataField: '_id', text: '#', isKey: true, hidden: true, },
      { dataField: 'anexo', text: 'Anexo', editable: false, validator: valid },
      { dataField: 'irpj', text: 'IRPJ', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "csll", text: 'CSLL', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "cofins", text: 'COFINS', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "pis", text: 'PIS/PASEP', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "cpp", text: 'CPP', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "ipi", text: 'IPI', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "iss", text: 'ISS', editable: true, validator: valid, formatter: valuesFormatter },
      { dataField: "icms", text: 'ICMS', editable: true, validator: valid, formatter: valuesFormatter }
    ]

    const columns_create = [
      { dataField: '_id', text: '#', isKey: true, hidden: true, },
      { dataField: 'anexo', text: 'Anexo', editable: true, validator: valid },
      { dataField: 'irpj', text: 'IRPJ', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "csll", text: 'CSLL', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "cofins", text: 'COFINS', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "pis", text: 'PIS/PASEP', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "cpp", text: 'CPP', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "ipi", text: 'IPI', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "iss", text: 'ISS', editable: true, validator: valid, formatter: valuesFormatterNew },
      { dataField: "icms", text: 'ICMS', editable: true, validator: valid, formatter: valuesFormatterNew }
    ]

    return (
      <>

        <MDBBtn
          className="btnDefault btnBuscarNfe" onClick={() => this.handleCreate()}>
          Criar Anexo
        </MDBBtn>

        <BootstrapTable
          keyField="_id"
          data={TabelaSimplesExcessoStore.obs.tabelasimples}
          columns={columns}
          cellEdit={cellEditFactory({ mode: 'click', blurToSave: true, beforeSaveCell })}
          wrapperClasses="TableDefault tabela-excesso"
        />

        <div style={{ marginBottom: 120 }} />

        <Dialog
          isOpen={this.obs.open_create}
          title="Novo Anexo"
        >
          <div className={Classes.DIALOG_BODY}>
            <BootstrapTable
              keyField="_id"
              data={data}
              columns={columns_create}
              cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
              wrapperClasses=" tabela-excesso"
            />
          </div>

          <br />

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.obs.open_create = false} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleSaveCreate(data)} />
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
